import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import InsuredDetails from '../../../components/Health/proposal/InsuredDetails';
import ProposerDetails from '../../../components/Health/proposal/ProposarDetails';
import MedicalHistory from '../../../components/Health/proposal/MedicalHistory';
import SummaryCard from '../../../components/Health/proposal/SummeryCard';
import {
  updateFirstPageData,
  getHealthEnquiryAPI,
  fgHealthProposal,
  fgHealthQuote,
} from '../../../Redux/HealthRedux';
import { axiosPOSTCall1 } from '../../../utilities/utils/apiPost';

const FormContainer = styled.div`
  width: 100%;
`;

const Layout = styled.div`
  display: flex;
  gap: 20px;
  justify-content: space-between;
  width: 85%;
  margin: 30px auto;
  padding: 30px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
`;

const LeftColumn = styled.div`
  flex: 3;
`;

const RightColumn = styled.div`
  flex: 1;
`;

const InsuranceForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [enquiryId, setEnquiryId] = useState(null);
      const { isFetching, septateCombinedRedux, error, success } = useSelector(
        (state) => state.health
      );

    const [step, setStep] = useState(1);
    const [members, setMembers] = useState({});

  const [selectedMemberIndex, setSelectedMemberIndex] = useState(0);

  const [formData, setFormData] = useState({
    // Step 2
    gender: '',
    mobile: '',
    email: '',
    address1: '',
    address2: '',
    state: '',
    city: '',
    pincode: '',
    annualIncome: '',
    pan: '',
    NomineeName: '',
    nomineeContact: '',
    NomineeRelation: '',
    NomineeDob: '',
    nomineeAddress: '',
    // Step 3
    medicalHistory: [],
    proposalMedicalQuestion: [],
    isSmoke: false,
  });
  

  const [errors, setErrors] = useState({});

    useEffect(() => {
      if (enquiryId) {
        dispatch(getHealthEnquiryAPI({ enquiryId }));
      }
    }, [enquiryId, dispatch]);

      useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const id = queryParams.get('enquiryId');
        setEnquiryId(id);
      }, []);

  function submitFixedPaymentForm(data) {
    const { action, checksum, paymentParams } = data;
  
    // Remove existing form if present
    const existingForm = document.getElementById('fixedPaymentForm');
    if (existingForm) existingForm.remove();
  
    const form = document.createElement('form');
    form.id = 'fixedPaymentForm';
    form.method = 'post';
    form.action = action;
  
    // Add inputs with fixed names and values from paymentParams + checksum
    const inputs = [
      { name: 'TransactionID', value: paymentParams.TransactionID },
      { name: 'PaymentOption', value: paymentParams.PaymentOption },
      { name: 'ResponseURL', value: paymentParams.ResponseURL },
      { name: 'ProposalNumber', value: paymentParams.ProposalNumber },
      { name: 'PremiumAmount', value: paymentParams.PremiumAmount },
      { name: 'UserIdentifier', value: paymentParams.UserIdentifier },
      { name: 'UserId', value: paymentParams.UserId },
      { name: 'FirstName', value: paymentParams.FirstName },
      { name: 'LastName', value: paymentParams.LastName },
      { name: 'Mobile', value: paymentParams.Mobile },
      { name: 'Email', value: paymentParams.Email },
      { name: 'Vendor', value: paymentParams.Vendor },
      { name: 'CheckSum', value: checksum },
    ];
  
    inputs.forEach(({ name, value }) => {
      const input = document.createElement('input');
      input.type = 'text';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    });
  
    // Optionally hide submit button
    const submit = document.createElement('input');
    submit.type = 'submit';
    submit.style.display = 'none';
    form.appendChild(submit);
  
    document.body.appendChild(form);
    form.submit();
  }

  const handlePayment = async (e) => {
    await axiosPOSTCall1(
      '/healthInsurance/health/payment/health-fg',
      {
        enquiryId: septateCombinedRedux.enquiryId,
      },
      (callback) => {
        submitFixedPaymentForm(callback.data);
      }
    );
  };

  const handleNext = (e) => {
    e.preventDefault();
    if (step === 1) {
      if (validateStep1()) {
      
        const children = [];

        for (const key in members) {
          if (key.toLowerCase() === 'son' || key.toLowerCase() === 'daughter') {
            children.push(members[key]);
          }
        }

        const updatedData = {
          enquiryId,
          insuredMembers: {
            ...members,
            child: children,
          },
        };

        dispatch(updateFirstPageData(updatedData)).then((callback) => {
          if (
            callback?.meta &&
            callback?.meta.requestStatus === 'fulfilled'
          ) {
            setStep(2);
          } else {
            console.error('Error updating first page data:', callback.payload);
          }
        });
      }
    } else if (step === 2 && validateStep2()) {
      const userDetail = {
        gender: formData.gender,
        education: formData.education,
        dob: formData.dob,
        occupationType: formData.occupationType,
        isTobbaco: formData.isTobbaco,
        annualIncome: formData.annualIncome,
        panNo: formData.pan,
        firstName: formData.firstName,
        middleName: formData.middleName,
        lastName: formData.lastName,
        email: formData.email,
        phone: formData.mobile,
        city: formData.city,
        state: formData.state,
        pinCode: formData.pincode,
        maritalStatus: formData.maritalStatus,
      };

      const children = [];

      for (const key in members) {
        if (key.toLowerCase() === 'son' || key.toLowerCase() === 'daughter') {
          children.push(members[key]);
        }
      }

      const insuredMembers = {
        ...members,
        child: children,
        self: {
          ...members.self,
          gender: formData.gender,
          mobile: formData.mobile,
          email: formData.email,
          address1: formData.address1,
          address2: formData.address2,
          state: formData.state,
          city: formData.city,
          pincode: formData.pincode,
          annualIncome: formData.annualIncome,
          pan: formData.pan,
          NomineeName: formData.NomineeName,
          nomineeContact: formData.nomineeContact,
          NomineeRelation: formData.NomineeRelation,
          NomineeDob: formData.NomineeDob,
          nomineeAddress: formData.nomineeAddress,
        },
      };

      const updatedData = {
        enquiryId,
        userDetail,
        insuredMembers,
      };

      dispatch(updateFirstPageData(updatedData)).then((callback) => {
        if (
          callback?.meta &&
          callback?.meta.requestStatus === 'fulfilled'
        ) {
          setStep(3);
        } else {
          console.error('Error updating first page data:', callback.payload);
        }
      });
      // setStep(3);
    } else if (step === 3) {
      // const children = [];

      // for (const key in members) {
      //   const lowerKey = key.toLowerCase();

      //   if (lowerKey === 'son' || lowerKey === 'daughter') {
      //     console.log("fuckkkkkk members",members)
      //     console.log("fuckkk2222 - formData", formData)
      //     const member = members[key];
      //     const questions = formData.proposalMedicalQuestion?.[key] || [];
      //     console.log(
      //       '🚀 ~ handleNext ~ questions:45454455',
      //       formData.proposalMedicalQuestion
      //     );

      //     children.push({
      //       ...member,
      //       relation: key,
      //       [`proposalMedicalQuestion_${lowerKey}`]: questions,
      //     });
      //     console.log("🚀 ~ handleNext ~ children:", children)
      //   }
      // }

      // // Remove child members (son/daughter) from flat members
      // const cleanedMembers = { ...members };
      // delete cleanedMembers.son;
      // delete cleanedMembers.daughter;

      // // Merge non-child proposalMedicalQuestion fields back
      // console.log("🚀 ~ formData.proposalMedicalQuestion:", formData.proposalMedicalQuestion)
      
      // Object.entries(formData.proposalMedicalQuestion || {}).forEach(
      //   ([relation, questions]) => {
      //     if (
      //       relation !== 'son' &&
      //       relation !== 'daughter' &&
      //       cleanedMembers[relation]
      //     ) {
      //       cleanedMembers[relation] = {
      //         ...cleanedMembers[relation],
      //         proposalMedicalQuestion: questions,
      //       };
      //     }
      //   }
      // );

      function mergeAndGroupMembers(fullMembers, formDataMembers) {
        const merged = {};
        const childRelations = ['son', 'daughter'];
        const children = [];

        // Extract firstName and relation from uniqueKey like "child_ww_son"
        const parseKey = (key) => {
          const parts = key.split('_');
          return {
            firstName: parts[1]?.toLowerCase(),
            relation: parts[2]?.toLowerCase(),
          };
        };

        Object.entries(fullMembers).forEach(([key, member]) => {
          const relation = member.relation?.toLowerCase();

          if (childRelations.includes(relation)) {
            const matched = (formDataMembers.child || []).find((c) => {
              const { firstName, relation: rel } = parseKey(c.uniqueKey);
              return (
                firstName === member.firstName?.toLowerCase() &&
                rel === relation
              );
            });

            children.push({
              ...member,
              proposalMedicalQuestion:
                matched?.proposalMedicalQuestion ||
                member.proposalMedicalQuestion ||
                [],
              isSmoke: matched?.isSmoke || member.isSmoke || false,
            });
          } else {
            merged[key] = {
              ...member,
              proposalMedicalQuestion:
                formDataMembers[key]?.proposalMedicalQuestion ||
                member.proposalMedicalQuestion ||
                [],
              isSmoke: formDataMembers[key]?.isSmoke || member.isSmoke || false,
            };
          }
        });

        if (children.length) {
          merged.child = children;
        }
        return merged;
      }
      

      const mergedMembers = mergeAndGroupMembers(
        members,
        formData.insuredMembers || {}
      );

      const updatedData = {
        ...formData,
        enquiryId,
        insuredMembers: mergedMembers,
      };

      dispatch(updateFirstPageData(updatedData))
        .then((callback) => {
          if (
            callback?.meta &&
            callback?.meta.requestStatus === 'fulfilled'
          ) {
            dispatch(fgHealthQuote({ enquiryId: enquiryId, QuoteAgainForSmoker: true })).then(
              () => {
                  dispatch(fgHealthProposal({ enquiryId: enquiryId })).then(
                    (res) => {
                      if (
                        res.payload.data?.Root?.Status?.toLowerCase() ===
                        'success'
                      ) {
                        alert('Proposal submitted successfully');
                        handlePayment(e);
                      } else {
                        alert(`Unable to submit proposal ${res.payload.message}`);
                        console.error('Error in proposal:', res.payload);
                        return
                      }
                    }
                  );
              }
            );
          } else {
            console.error('Error updating first page data:', callback.payload);
          }
        });
    }
  };

  const handleBack = () => {
    if (step > 1) setStep(step - 1);
  };


const validateStep1 = () => {
  let err = {};

  // Iterate over each member like self, spouse, etc.
  Object.keys(members).forEach((relation) => {
    const member = members[relation];

    const requiredFields = [
      'firstName',
      'lastName',
      'occupation',
      'relation',
      'dob',
      'gender',
      'height',
      'weight',
      'NomineeName',
      'NomineeRelation',
      'NomineeDob',
    ];

    requiredFields.forEach((key) => {
      // If any required field is missing or empty, mark it as required
      if (!member[key]?.trim()) {
        err[`${relation}-${key}`] = 'Required';
      }
    });

    // Ensure the nominee's age is at least 18
    // CALCULATE AGE USING DOB
    if (member.NomineeDob) {
      const dob = new Date(member.NomineeDob);
      let age = new Date().getFullYear() - dob.getFullYear();
      const monthDiff = new Date().getMonth() - dob.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && new Date() < dob)) {
        age--;
      }
      if (age < 18) {
        err[`${relation}-NomineeDob`] = 'Nominee age must be 18 or older';
      }
    }

    // Ensure the member's DOB is not in the future
    if (member.dob && new Date(member.dob) >= new Date()) {
      err[`${relation}-dob`] = 'Date of birth cannot be today or in the future';
    }
  });

  // Set the errors and return true if no errors exist
  setErrors(err);
  return Object.keys(err).length === 0;
};


  const validateStep2 = () => {
    const required = [
      'mobile',
      'email',
      'address1',
      'city',
      'pincode',
      'NomineeName',
      'NomineeRelation',
      'NomineeDob',
      'gender',
      'pan',
    ];
    let err = {};

    required?.forEach((key) => {
        const value = formData[key];
        if (typeof value !== 'string' || value.trim() === '') {
          err[key] = 'Required';
        }
    });

    if (formData.mobile && !/^[0-9]{10}$/.test(formData.mobile))
      err.mobile = 'Invalid mobile';
    if (
      formData.email &&
      !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email)
    )
      err.email = 'Invalid email';

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  return (
    <Layout>
      <LeftColumn>
        <FormContainer>
          {step === 1 && (
            <InsuredDetails
              members={members}
              enquiryId={enquiryId}
              setMembers={setMembers}
              selectedIndex={selectedMemberIndex}
              setSelectedIndex={setSelectedMemberIndex}
              errors={errors}
              onContinue={handleNext}
            />
          )}
          {step === 2 && (
            <ProposerDetails
              values={formData}
              setValues={setFormData}
              septateCombinedRedux={septateCombinedRedux}
              enquiryId={enquiryId}
              errors={errors}
              isFetching={isFetching}
              success={success}
              onContinue={handleNext}
              onBack={handleBack}
            />
          )}
          {step === 3 && (
            <MedicalHistory
              setValues={setFormData}
              values={formData}
              errors={errors}
              isFetching={isFetching}
              success={success}
              onContinue={handleNext}
              septateCombinedRedux={septateCombinedRedux}
              slug="health-fg"
              onBack={handleBack} 
            />
          )}
        </FormContainer>
      </LeftColumn>
      <RightColumn>
        {Object.keys(septateCombinedRedux).length !== 0 ? (
          <SummaryCard data={septateCombinedRedux} />
        ) : (
          <div style={{ textAlign: 'center' }}>Loading summary...</div>
        )}
      </RightColumn>
    </Layout>
  );
};

export default InsuranceForm;